import { Button } from "@mantine/core"
import classes from './PreviewActionButtons.module.scss';
import { useDispatch } from "react-redux";
import { cameraActions } from "../redux/cameraSlice";
import { interactionActions } from "../redux/interactionSlice";


export const PreviewActionButtons = () => {

  const dispatch = useDispatch();

  const resetPreview = () => {
    dispatch(cameraActions.reset());
    dispatch(interactionActions.resetState());
    dispatch(interactionActions.resetBoundary());
  }

  return <div className={classes.previewActionButtonsContainer}>
    <Button onClick={resetPreview}>Reset</Button>
  </div>
}